import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { supabase } from "./supabaseclient";
import logo from "./logo.png";
import "./Login.css";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");

  const handleSignIn = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setInfo("");

    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) setError(error.message);
    else navigate(location.state?.from || "/");

    setLoading(false);
  };

  return (
    <div className="login-wrap">
      <form onSubmit={handleSignIn} className="login-card">
        <img src={logo} alt="Logo" className="logo" />

        {/* Updated heading */}
        <h2 className="login-title">Triple W Storage</h2>
        <p className="login-info">
  For questions about storage or shipping, please contact Jacob at (615) 806-3361
</p>

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        {error && <div className="err">{error}</div>}
        {info && <div className="msg">{info}</div>}

        <button disabled={loading}>
          {loading ? "Signing in…" : "Sign In"}
        </button>

        {/* Added Forgot Password button */}
        <button
          type="button"
          className="muted-link"
          onClick={() => navigate("/start-reset")}
        >
          Forgot password?
        </button>
      </form>
    </div>
  );
}
